import { useState ,useRef} from "react";
import { colorClasses } from "../../utils";
import Feedback from "../Feedback";
import ActionButtons from "../ActionButtons";
import correct from "../../assets/sounds/correct.wav"
import wrong from "../../assets/sounds/wrong.wav"
import retry from "../../assets/sounds/retry.wav"
import check from "../../assets/sounds/check.wav"
const PaintColorsExercise = ({ exercise }) => {
  const [state, setState] = useState({
    selectedColor: null,
    itemColors: Array(exercise.itemCount).fill(null)
  });
  const correctSound = useRef(new Audio(correct))
  const wrongSound = useRef(new Audio(wrong))
  const retrySound = useRef(new Audio(retry))
  const checkSound = useRef(new Audio(check))
  const handlePaintClick = (index) => {
    if (!state.selectedColor) {
      alert('⚠️ اختر لوناً أولاً من الألوان بالأعلى!');
      return;
    }
    checkSound.current.currentTime = 0;
    checkSound.current.play();
    const newState = { ...state };
    newState.itemColors[index] = state.selectedColor;
    setState(newState);
  };

  const handleReset = () => {
    retrySound.current.currentTime = 0;
    retrySound.current.play()
    setState({ selectedColor: null, itemColors: Array(exercise.itemCount).fill(null) });
  };

  return (
    <>
      <div className="flex gap-2 sm:gap-4 my-3 sm:my-5 flex-wrap justify-center">
        {exercise.colors.map((color, idx) => (
          <div
            key={idx}
            onClick={() => setState({ ...state, selectedColor: color })}
            className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full cursor-pointer transition-all hover:scale-110 ${
              colorClasses[color]
            } border-2 sm:border-4 ${
              state.selectedColor === color ? 'border-black' : 'border-gray-500'
            }`}
          />
        ))}
      </div>
      <div className="flex gap-3 sm:gap-5 my-3 sm:my-5 flex-wrap justify-center bg-gray-100 p-3 sm:p-5 rounded-xl sm:rounded-2xl">
        {Array(exercise.itemCount).fill(0).map((_, idx) => (
          <div
            key={idx}
            onClick={() => handlePaintClick(idx)}
            className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-3xl sm:text-4xl cursor-pointer transition-all hover:scale-110 rounded-lg ${
              state.itemColors[idx] ? colorClasses[state.itemColors[idx]] : ''
            }`}
          >
            {exercise.emoji}
          </div>
        ))}
      </div>
      {exercise.openEnded && (
        <div className="mt-3 sm:mt-4 p-3 sm:p-4 bg-blue-100 rounded-xl text-blue-900 text-center text-sm sm:text-base font-bold">
          {exercise.successMessage}
        </div>
      )}
      <ActionButtons onReset={handleReset} showCheck={false} />
    </>
  );
};

export default PaintColorsExercise;